import { CrossIcon, EditIcon, SaveIcon } from '../../../utils/SVGIcon';
import { useProfileInfo } from '../UserProfileProvider';

function ActionButton({ isEditMode, saveClick, editClick, cancelEditClick }) {
    if (isEditMode) {
        return (
            <div className="flex justify-center items-center gap-1.5">
                <button
                    type="button"
                    onClick={saveClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                >
                    <SaveIcon />
                </button>
                <button
                    type="button"
                    onClick={cancelEditClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 text-[#506B76] rounded-full"
                >
                    <CrossIcon />
                </button>
            </div>
        );
    }
    return (
        <button
            type="button"
            onClick={editClick}
            className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
        >
            <EditIcon />
        </button>
    );
}

function Value({ isEditMode, name, inputValue, handleChange }) {
    if (isEditMode) {
        return (
            <select
                name="gender"
                value={inputValue || ''}
                onChange={handleChange}
                className="w-11/12 outline-none text-primary text-base md:text-xl font-medium bg-transparent py-1 px-1 pr-0 rounded-md relative -left-2 h-[36px]"
            >
                <option value="">Select Gender</option>
                {['Male', 'Female', 'Other']?.map((item) => (
                    <option key={item} value={item?.toLowerCase()}>
                        {item}
                    </option>
                ))}
            </select>
        );
    }
    return (
        <input
            type="text"
            name={name}
            value={inputValue || ''}
            readOnly
            className="w-full outline-none text-primary text-base md:text-xl capitalize font-medium bg-transparent py-1 px-2 rounded-md relative -left-2 h-[36px]"
        />
    );
}

function UserGenderInfoCard({ title, name, value, saveClick }) {
    const { propertyName, handleEditClick, handleReset, formData, handleChange } = useProfileInfo();

    // --Check if the input is in edit mode
    const isEditMode = propertyName?.length && propertyName === name;

    const inputValue = isEditMode ? formData[name] : value;

    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm md:text-base font-normal">
                    {title || '--'}
                </h3>
                <Value
                    isEditMode={isEditMode}
                    name={name}
                    inputValue={inputValue}
                    handleChange={handleChange}
                />
            </div>
            <div className={propertyName?.length && propertyName !== name ? 'hidden' : 'block'}>
                <ActionButton
                    isEditMode={isEditMode}
                    saveClick={saveClick}
                    editClick={() => handleEditClick(name, value)}
                    cancelEditClick={handleReset}
                />
            </div>
        </div>
    );
}

export default UserGenderInfoCard;
